import styled from 'styled-components'

export const StyledExternalLink = styled.a`
  background: none;
  border: none;
  display: inline-block;
  outline: none;
  padding: 0;
  user-select: none;
  text-decoration: none;

  > * {
    vertical-align: middle;
  }

  > span {
    border-bottom: ${({ underline }) => underline ? '2px solid transparent' : 'none'};
  }

  &:hover,
  &:active,
  &:focus {
    > span {
      border-color: ${({ theme }) => theme.colors.petrolBlue};
    }
  }
`
